import {ofType} from 'redux-observable'
import {ajax} from 'rxjs/ajax';
import {concat, merge as rxMerge, of} from 'rxjs';
import {catchError, debounceTime, filter, map, mergeMap, partition} from 'rxjs/operators'
import assign from "lodash/assign";
import i18next from 'i18next';

import {
    STEP_MOVED,
    UPDATE_ACTIVE_FLOW,
    updateActiveFlowRequestFail,
    updateActiveFlowRequestStart,
    updateActiveFlowRequestSuccess,
    updateStepRequestFail,
    updateStepRequestStart,
    updateStepRequestSuccess,
} from "../actions/Steps";


export const stepMovedEpic = (action$, state$) =>
    action$.pipe(
        ofType(STEP_MOVED),
        debounceTime(300),
        filter(action => (action.stepId > 0)),
        mergeMap(
            action => {
                const data = {
                    id: action.stepId,
                    shop_id: state$.value.Shops.activeShop.id,
                    html_position_x: action.x,
                    html_position_y: action.y,
                };

                return concat(
                    of(updateStepRequestStart(data)),
                    ajax.patch(
                        process.env.REACT_APP_API_URL + `step/steps/${action.stepId}/`,
                        data,
                        {
                            Authorization: `Bearer  ${state$.value.Auth.authToken}`,
                            'Content-Type': 'application/json',
                        }
                    ).pipe(
                        map(response => {
                            if (response.response.status === 'ok') {
                                return updateStepRequestSuccess(response.response.result)
                            } else {
                                return updateStepRequestFail(response.response.errors);
                            }
                        }),
                        catchError(error => {
                            return of(updateStepRequestFail({
                                'common': i18next.t('errors.common.request_sent', 'Error sending request'),
                            }));
                        }),
                    )
                );
            }
        ),
    );

export const updateFlowConfigEpic = (action$, state$) => {
    const [zoom$, position$] = action$.pipe(
        ofType(UPDATE_ACTIVE_FLOW),
        filter(
            (action) => (
                action.data.html_graph_x !== undefined
                || action.data.html_graph_y !== undefined
                || action.data.html_graph_zoom !== undefined
            )
        ),
        partition(action => (action.data.html_graph_zoom !== undefined)),
    );

    return rxMerge(
        zoom$.pipe(
            debounceTime(300),
        ),
        position$.pipe(
            debounceTime(300),
        ),
    ).pipe(
        filter(() => state$.value.Steps.activeFlow),
        mergeMap(
            action => {
                const data = assign(
                    action.data,
                    {
                        id: state$.value.Steps.activeFlow.id,
                    },
                );

                return concat(
                    of(updateActiveFlowRequestStart(data)),
                    ajax.patch(
                        process.env.REACT_APP_API_URL + `step/flows/${data.id}/`,
                        data,
                        {
                            Authorization: `Bearer  ${state$.value.Auth.authToken}`,
                            'Content-Type': 'application/json',
                        }
                    ).pipe(
                        map(response => {
                            if (response.response.status === 'ok') {
                                return updateActiveFlowRequestSuccess(response.response.result);
                            } else {
                                return updateActiveFlowRequestFail(response.response.errors);
                            }
                        }),
                        catchError(error => {
                            return of(updateActiveFlowRequestFail({
                                'common': i18next.t('errors.common.request_sent', 'Error sending request'),
                            }));
                        }),
                    )
                );
            }
        ),
    );
};
